<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-select
          v-if="numberKeyGenerate > 1"
          ref="dependents"
          v-model="form.no_dependents"
          :rules="MIXINS_REQUIRED_RULES"
          :items="dependentItems"
          label="No. of Dependents"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.first_name"
          :rules="MIXINS_REQUIRED_RULES"
          label="First Name"
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.last_name"
          :rules="MIXINS_REQUIRED_RULES"
          label="Last Name"
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.middle_name"
          :rules="MIXINS_REQUIRED_RULES"
          label="Middle Name"
          dense
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="form.address1"
          :rules="MIXINS_REQUIRED_RULES"
          label="Address 1"
          dense
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="form.address2"
          label="Address 2"
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.city"
          :rules="MIXINS_REQUIRED_RULES"
          label="City"
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.state"
          :rules="MIXINS_REQUIRED_RULES"
          label="State"
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.zip_code"
          :rules="MIXINS_REQUIRED_RULES"
          label="Zip Code"
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.phone_number"
          :rules="MIXINS_REQUIRED_RULES"
          label="Phone Number"
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
         <v-text-field
            v-model="form.email"
            :rules="[...MIXINS_REQUIRED_RULES, ...MIXINS_EMAIL_RULES]"
            label="Email"
            dense
          />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.confirm_email"
          :rules="[...MIXINS_REQUIRED_RULES, ...MIXINS_EMAIL_RULES]"
          label="Confirm Email"
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-menu
          v-model="birthdateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              placeholder="M/D/YYYY"
              :rules="MIXINS_REQUIRED_RULES"
              v-model="form.birthdate"
              label="Birthday"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="form.birthdate"
            ref="birthdate"
            no-title
            @input="birthdateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          ref="source"
          v-model="form.source"
          :items="sources"
          label="Source of Information"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-radio-group
          row
          label="Sex"
          v-model="form.sex"
          :rules="MIXINS_REQUIRED_RULES"
        >
          <v-radio
            label="Male"
            value="male"
          ></v-radio>
          <v-radio
            label="Female"
            value="female"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="agree"
          light
          class="mt-1 mb-1"
          :rules="[() => !!agree || 'You must agree to continue']"
        >
          <template slot="label">
            <div slot='label' class="black--text">I agree with the <a @click.stop href="/terms-and-conditions/medgate-shop">Terms &amp; Conditions</a></div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    agree: false,
    birthdateMenu: false,
    sources: [
      "Colleague",
      "Company",
      "Medgate Employee",
      "Newsletter",
      "Search Engine",
      "Social Media"
    ],
  }),
  props: {
    /**
     * Collection of data that will be supplied to this component
     */
    form: {
      type: Object,
      default: () => {
        return {};
      }
    },
    numberKeyGenerate: {
      type: Number,
      default: 1
    }
  },
  computed: {
    dependentItems: function() {
      let items = [];
      for (let index = 1; index <= this.numberKeyGenerate; index++) {
        items.push(index);        
      }

      return items;
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    }
  }
};
</script>
